import React, { useState } from 'react';
import usePaginatedApi from 'components/hooks/usePaginationApi';
import LeftNavHeader from 'pages/studio/Components/LeftNavHeader';
import LeftNavSearch from 'pages/studio/Components/LeftNavSearch';
import IconElement from './IconElement';
import { IconContainer } from './styles';
import { palette } from 'config/theme';
import { Typography } from '@mui/material';

const Icons = (props) => {
  const { elementType, setElementType } = props;
  const [buttonSearch, setButtonSearch] = useState('');
  const elementConfigs = {
    ICONS: { api: 'assets', params: { contenttype: { $eq: 'icon' } } },
  };

  const { api, params: apiParams } = elementConfigs[elementType] || { api: '', params: {} };

  const { data, loading, error, loadMore, searchItems, count } = usePaginatedApi(api, 16, apiParams);
  const handleBack = () => {
    setElementType('ELEMENTS');
  };
  const handleSearch = (value) => {
    searchItems(value, 'name');
    setButtonSearch(value);
  };
  const clearSearch = () => {
    setButtonSearch('');
    searchItems('', 'name');
  };
  return (
    <IconContainer>
      <LeftNavHeader elementType={elementType} setElementType={setElementType} handleBack={handleBack} />
      <LeftNavSearch
        searchValue={buttonSearch}
        handleSearch={handleSearch}
        placeholder={'Search Icons'}
        clearSearch={clearSearch}
      />
        <IconElement
          data={data && data?.map((item) => item?.attributes?.asset?.data[0]?.attributes)}
          elementLoadMore={loadMore}
          elementLoading={loading}
          elementError={error}
          elementCount={count}
          dataFound={data}
          buttonSearch={buttonSearch}
          clearSearch={clearSearch}
        />
    
    </IconContainer>
  );
};

export default Icons;
